import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { IconPencil } from "@tabler/icons-react";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const DataProfileComp = (props) => {
  // console.log(props);
  const [role, setRole] = useState("");

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/profile/data.fetchOneUser');
    }
  };

  useEffect(() => {
    fetchOneUser();
  }, []);

  return (
    <>
      {/*begin::details View*/}
      <div className="card mb-5 mb-xl-10">
        {/*begin::Card header*/}
        <div className="card-header cursor-pointer">
          {/*begin::Card title*/}
          <div className="card-title m-0">
            <h3 className="fw-bolder m-0">Detil Profil</h3>
          </div>
          {/*end::Card title*/}
          {/*begin::Action*/}
          {role === "Administrator" ? (
            <button
              type="button"
              onClick={() => props.handleEdit()}
              className="btn btn-primary align-self-center"
            >
              <IconPencil stroke={2} /> Ubah Profil
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-secondary align-self-center"
              disabled={true}
            >
              Ubah Profil
            </button>
          )}
          {/*end::Action*/}
        </div>
        {/*begin::Card header*/}
        {/*begin::Card body*/}
        <div className="card-body p-9">

          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Rumah Sakit</label>


            <div className="col-lg-8 fv-row">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.namaRs}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">
              Kode Rumah Sakit
            </label>


            <div className="col-lg-8 fv-row">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.kodeRs}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Direktur</label>


            <div className="col-lg-8 fv-row">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.direktur}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Email</label>


            <div className="col-lg-8 fv-row">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.email}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Telp</label>


            <div className="col-lg-8 fv-row">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.telp}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Website</label>


            <div className="col-lg-8 fv-row">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.website}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Alamat</label>


            <div className="col-lg-8 fv-row">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.alamat}
              </span>
            </div>

          </div>

          <hr></hr>

          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">PIC</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.contactPerson.namaDepan}{" "}
                {props.contactPerson.namaBelakang} (
                {props.contactPerson.namaPanggilan})
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Gender</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.contactPerson.gender === "Pria" ? "Pria" : "Wanita"}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Email</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.contactPerson.email}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">
              Nomor Handphone
            </label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.contactPerson.hp1} | {props.contactPerson.hp2}
              </span>
            </div>

          </div>

          {/* Configuration Email */}
          {/* <hr></hr> */}

          {/* <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">
              Status Send Email
            </label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.statusSendEmail === "yes"
                  ? "Aktif"
                  : "Non Aktif"}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">SMTP Host</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.smtpHost}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">SMTP Port</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.smtpPort}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">SMTP Username</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.smtpUsername}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">SMTP Password</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.smtpPassword}
              </span>
            </div>

          </div>


          <div className="row mb-7">

            <label className="col-lg-4 fw-bold text-muted">Email From</label>


            <div className="col-lg-8">
              <span className="fw-bold text-gray-800 fs-6">
                {props.profile?.smtpEmailFrom}
              </span>
            </div>

          </div> */}
        </div>
        {/*end::Card body*/}
      </div>
      {/*end::details View*/}
    </>
  );
};

export default DataProfileComp;
